import React, { useEffect } from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import { connect, useDispatch } from 'react-redux';
import { setNextPage, setOverlay, setPrevPage } from '../../../redux/slices/appStateSlice';

const QuoteSummaryPage = ({ rendering, fields, interstitial }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setOverlay(null));
  }, []);

  useEffect(() => {
    if (fields?.prevPage?.value?.href) {
      dispatch(setPrevPage(fields.prevPage.value.href));
    }
    if (fields?.nextPage?.value?.href) {
      dispatch(setNextPage(fields.nextPage.value.href));
    }
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }
  }, []);

  return (
    <div className="vds-page-container vds-page-container--d2c">
      <div style={{ display: interstitial ? 'none' : '' }}>
        <Placeholder name="quoteSummary-navigation" rendering={rendering} />
        <Placeholder name="quoteSummary-content" rendering={rendering} />
        <Placeholder name="quoteSummary-footer" rendering={rendering} />
      </div>
      <Placeholder name="quoteSummary-overlays" rendering={rendering} />
    </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    ...props,
    interstitial: state.appState?.overlay?.interstitial,
  };
};
export default connect(mapStateToProps)(QuoteSummaryPage);
